/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressNewApiModel } from './addressNewApiModel';


export interface CompanyDetailsApiModel { 
    name: string;
    ico: string;
    dic: string;
    icDPH: string;
    skNaceCode: string;
    addressDto: AddressNewApiModel;
}

